<template>
  <v-container fluid>
    <div>
      <div id="cylinder" class="waves">
        <div class="wave wave--back" style="height: 43%; color: #1976d2;">
          <div class="water" :style="{ height: level*2 + '%' }">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 350 32"
              preserveAspectRatio="none"
              :style="{ position: 'absolute', top: (level === 100 || level === 0? '0px' : '-18px') }"
            >
              <path d="M350,17.32V32H0V17.32C116.56,65.94,175-39.51,350,17.32Z"></path>
            </svg>
          </div>
          <div class="water" :style="{ height: level*2 + '%' }">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 350 32"
              preserveAspectRatio="none"
              :style="{ position: 'absolute', top: (level === 100 || level === 0 ? '0px' : '-18px') }"
            >
              <path d="M350,17.32V32H0V17.32C116.56,65.94,175-39.51,350,17.32Z"></path>
            </svg>
          </div>
        </div>
        <div class="wave wave--front" style="height: 43%; color: #1976d2;">
          <div class="water" :style="{ height: level*2 + '%' }">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 350 32"
              preserveAspectRatio="none"
              :style="{ position: 'absolute', top: (level === 100 || level === 0 ? '0px' : '-18px') }"
            >
              <path
                d="M0 32 V17.32 Q 87.5 0, 175 17.32 T350 17.32 V32 Z"
                fill="currentColor"
              />
            </svg>
          </div>
          <div class="water" :style="{ height: level*2 + '%' }">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 350 32"
              preserveAspectRatio="none"
              :style="{ position: 'absolute', top: (level === 100 || level === 0 ? '0px' : '-18px') }"
            >
              <path
                d="M0 32 V17.32 Q 87.5 0, 175 17.32 T350 17.32 V32 Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
        <div class="percent">
          <div class="percent-text">{{ level }}%</div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Tank",
  props: {
    level: {
      type: Number,
      default: 100,
    },
  },
};
</script>

<style scoped>
div {
  display: block;
  unicode-bidi: isolate;
}

.waves {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.4s ease;
  transform-origin: bottom center;
}

#cylinder {
  height: 250px;
  width: 190px;
  margin-bottom: 0;
  box-sizing: border-box;
  border-radius: 100% / 30%;
  background: #D3D3D3;
  opacity: 0.8;
  z-index: 1;
  overflow: hidden;
}

#cylinder::before {
  content: "";
  position: absolute;
  background: rgba(27, 34, 53, 0.8);
  border: 0 solid transparent;
  border-radius: 100%;
  z-index: 500;
  width: 100%;
  height: 80px;
  left: 0;
  opacity: 1;
}

.wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 55%;
  animation: wave 3s linear infinite;
}

.wave--back {
  z-index: 1;
  animation-direction: reverse;
}

.water:first-of-type {
  transform: translate(-100%);
}

.water {
  position: absolute;
  bottom: 0;
  width: 110%;
  fill: #1976d2;
  background-color: #1976d2;
}

#cylinder::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0 solid transparent;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.36) 47%,
    rgba(255, 255, 255, 0) 100%
  );
}

.wave--front {
  z-index: 2;
}

.percent {
  z-index: 1000;
  position: relative;
  bottom: -100px;
  font-size: 35px;
  font-weight: bolder;
  color: #1b2235cc;
  transition: opacity 0.4s 0.2s, transform 0.4s 0.2s;
  text-align: center;
}

.percent-text {
  display: inline-block;
  min-width: 50px;
}

svg:not(:root) {
  overflow-clip-margin: content-box;
  overflow: hidden;
}

@keyframes wave {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
